import Product from '@/models/storePanel/Product';
const getDefaultState = () => ({
  showImageUpload: false,
  showWeekdays: false,
  categories: [],
  products: [],
  product: new Product(),
  externalLinks: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setShowImageUpload(state, payload) {
      state.showImageUpload = payload;
    },

    setShowWeekdays(state, payload) {
      state.showWeekdays = payload;
    },

    setCategories(state, payload) {
      state.categories = payload;
    },

    setItems(state, payload) {
      state.products = payload;
    },

    setItem(state, payload) {
      state.product = new Product(payload);
    },

    addItem(state, payload) {
      state.products.unshift(payload);
    },

    updateItem(state, payload) {
      let index = state.products.findIndex((p) => p.product_id === payload.product_id);
      state.products.splice(index, 1, payload);
    },

    removeItem(state, id) {
      state.products = state.products.filter((p) => p.product_id !== id);
    },

    setExternalLinks(state, payload) {
      state.externalLinks = payload;
    },
  },

  actions: {
    async getCategories({ commit }) {
      try {
        const { data } = await Product.getCategories();

        const { product_categories } = data.data;
        commit('setCategories', product_categories);
      } catch (ex) {
        console.error(ex.response.data);
      }
    },

    async getItems({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });

        const { data } = await Product.get(body.query, filter);
        const { products, pagination } = data.data;

        commit('setItems', products);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async create({ commit, dispatch, state, rootState }, image) {
      try {
        commit('setLoading', true, { root: true });

        let product = { ...state.product };
        product.maximum_price_per_transaction = product.maximum_price_per_transaction || 0;

        delete product.image;
        delete product.parent_product_id;
        Product.clearFalsyValues(product);

        if (!product.name.en) product.name.en = product.name.el;
        if (!product.name.it) product.name.it = product.name.el;
        if (!product.description.en) product.description.en = product.description.el;
        if (!product.description.it) product.description.it = product.description.el;

        const { data } = await Product.create(product);

        if (image) {
          dispatch('uploadImage', {
            item: data.data.product,
            image,
            mode: 1,
          });
        } else {
          commit('addItem', data.data.product);
          commit('setServerItemsLength', rootState.serverItemsLength + 1, { root: true });
          commit('setLoading', false, { root: true });
          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully created product!',
            },
            { root: true }
          );
        }
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async update({ commit, dispatch, state }, { newValues, image }) {
      try {
        commit('setLoading', true, { root: true });
        let product = { ...state.product };
        product.maximum_price_per_transaction = product.maximum_price_per_transaction || 0;

        if (typeof newValues === 'object') {
          if (Object.keys(newValues).length > 0) {
            await Product.update(product.product_id, newValues);
          }
        }

        if (image) {
          dispatch('uploadImage', {
            item: product,
            image,
            mode: 2,
          });
        } else {
          // commit("updateItem", data.data.product);
          dispatch('getItems', { filters: {}, query: '?page=1' });
          commit('setLoading', false, { root: true });
          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully updated product!',
            },

            { root: true }
          );
        }
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async remove({ commit, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });

        await Product.delete(state.product.product_id);

        commit('setServerItemsLength', rootState.serverItemsLength - 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDeleteDialog', false, { root: true });
        commit('removeItem', state.product.product_id);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully deleted product!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async uploadImage({ commit, rootState }, { item, image, mode }) {
      try {
        const fd = new FormData();
        fd.append('image', image);

        const { data } = await Product.uploadImage(item.product_id, fd);

        item.image = data.data.image;

        if (mode === 1) {
          commit('addItem', item);
          commit('setServerItemsLength', rootState.serverItemsLength + 1, { root: true });
        } else {
          commit('updateItem', item);
        }
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: `You have successfully ${mode === 1 ? 'created' : 'updated'} product!`,
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async getExternalLinks({ commit }, query) {
      try {
        const { data } = await Product.getExternalLinks(query);

        const { store_external_links, pagination } = data.data;
        commit('setExternalLinks', store_external_links);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
      } catch (ex) {
        console.error(ex.response.data);
      }
    },
  },
};
